"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { RiCloseLine, RiFullscreenLine } from "react-icons/ri";
import { ProgressBarLink } from "@/components/progress-bar";
import Button from "@/components/ui/button";
import { ProgressLine } from "@/components/ui/progress-line";
import { Skeleton } from "@/components/ui/skeleton";
import { groupByPersona, nextOpenTask } from "@/lib/training";
import { PersonaIcon } from "./persona-icon";
import { TrainingTaskRow } from "./training-task-row";
import { useAdvanceOnSettle } from "./use-advance-on-settle";
import { useTraining } from "@/api/provider/training/training-query";
import { closeTrainingSidebar } from "@/features/sidebar/training-sidebar";
export function TrainingSidebarPanel(t0) {
  const $ = _c(40);
  const {
    onClose
  } = t0;
  const {
    data,
    isLoading
  } = useTraining();
  let t1;
  if ($[0] !== data) {
    t1 = data ? nextOpenTask(data) : null;
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const next = t1;
  const [expanded, setExpanded] = useState(next?.id ?? null);
  let t2;
  if ($[2] !== data) {
    t2 = data ? groupByPersona(data) : [];
    $[2] = data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sections = t2;
  useAdvanceOnSettle(data?.items, expanded, next, setExpanded);
  if (isLoading) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex h-full w-full flex-col gap-3 px-4 py-3"><Skeleton className="h-4 w-2/3" /><Skeleton className="h-1 w-full" />{Array.from({
          length: 8
        }).map(_temp)}</div>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (!data?.plan) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p className="text-caption text-foreground-secondary">Pick your role to get your training list.</p>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">{t3}<Button asChild={true} variant="secondary" size="sm"><ProgressBarLink href="/training">Choose a role</ProgressBarLink></Button></div>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const total = data.totals.open + data.totals.done + data.totals.skipped;
  const settled = data.totals.done + data.totals.skipped;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "var(--right-sidebar-width, 100%)"
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-body-strong text-foreground">Training</h2>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = ` / ${total}`;
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="text-foreground-muted">{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== settled || $[12] !== t6) {
    t7 = <span className="text-caption-strong tabular-nums text-foreground">{settled}{t6}</span>;
    $[11] = settled;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Button asChild={true} variant="ghost" size="icon-sm" aria-label="Open full page" tooltip="Full page"><ProgressBarLink href="/training" onClick={_temp2}><RiFullscreenLine className="size-3.5" /></ProgressBarLink></Button>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== onClose) {
    t9 = onClose && <Button variant="ghost" size="icon-sm" onClick={onClose} aria-label="Close training" icon={<RiCloseLine className="size-4" />} />;
    $[15] = onClose;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className="flex items-center justify-between gap-2">{t4}<div className="flex items-center gap-1">{t7}{t8}{t9}</div></div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = `Training: ${settled} of ${total} tasks done or skipped`;
  let t12;
  if ($[20] !== settled || $[21] !== t11 || $[22] !== total) {
    t12 = <ProgressLine done={settled} total={total} label={t11} />;
    $[20] = settled;
    $[21] = t11;
    $[22] = total;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== data.plan.practicePatient) {
    t13 = data.plan.practicePatient && <p className="truncate text-caption text-foreground-secondary">{"Practice patient: "}<ProgressBarLink href={`/patient/${data.plan.practicePatient.id}`} className="font-medium text-foreground underline-offset-2 hover:underline">{data.plan.practicePatient.name}</ProgressBarLink></p>;
    $[24] = data.plan.practicePatient;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t13) {
    t14 = <div className="shrink-0 space-y-2.5 border-b border-border px-4 py-3">{t10}{t12}{t13}</div>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== expanded || $[31] !== sections) {
    let t16;
    if ($[33] !== expanded) {
      t16 = section => <section key={section.persona}><h3 className="flex items-center gap-1.5 py-1 text-overline font-semibold text-foreground-secondary"><PersonaIcon persona={section.persona} className="size-3.5" />{section.label}<span className="ml-auto font-normal tabular-nums text-foreground-muted">{section.openCount}</span></h3><ul>{section.items.map(item => <TrainingTaskRow key={item.id} item={item} expanded={expanded === item.id} onToggleExpanded={() => setExpanded(prev => prev === item.id ? null : item.id)} surface="sidebar" />)}</ul></section>;
      $[33] = expanded;
      $[34] = t16;
    } else {
      t16 = $[34];
    }
    t15 = sections.map(t16);
    $[30] = expanded;
    $[31] = sections;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[35] !== t15) {
    t16 = <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-4 py-3">{t15}</div>;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t16) {
    t17 = <div className="h-full w-full min-w-0 flex-1 overflow-hidden"><div className="flex h-full flex-col overflow-hidden" style={t3}>{t14}{t16}</div></div>;
    $[37] = t14;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp2(event) {
  if (event.metaKey || event.ctrlKey) {
    return;
  }
  closeTrainingSidebar();
}
function _temp(_, i) {
  return <Skeleton key={i} className="h-6 w-full" />;
}